module.exports = __webpack_public_path__ + "media/images/ui__arrowRight-dc5b3d32146af02fc9e3c97dba0b4b3b.png";